import { FunctionComponent } from 'react'

import { TabProps } from './types'

export const InteractiveTab: FunctionComponent<
  React.PropsWithChildren<TabProps>
> = ({ children }) => {
  return <>{children}</>
}
